import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import {GridContainer, GridItem} from '../../../../../../Common/DesignSystem/Grid';
import EmptyState from '../../../../../../Common/EmptyState';

import axios from "axios";
import i18n from'i18next';
import { Trans } from 'react-i18next';
import { CaptionMedium, P2Bold, P3, P3Bold } from '../../../../../../Common/DesignSystem/Text';
import Button from '../../../../../../Common/DesignSystem/Button';
import Icon from '../../../../../../Common/DesignSystem/Icons/Icon';
import colours from '../../../../../../Common/DesignSystem/Colours';

const VehicleSpecsTab = (props) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    }

    const openSpecSheet = () => {
        const win = window.open(props.vehicle.specSheetUrl);
        win.focus();
    }

    const styles = {
        imageContainer: {
            borderRadius: 16, 
            // boxShadow: '0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08)',
        },
        activeIconContainerStyle: { 
            marginRight: 8, 
            borderRadius: '8px', 
            color: colours.primary.blue, 
            backgroundColor: colours.functional.hover_secondaryblue
        },
        inactiveIconContainerStyle: {
            marginRight: 8,
            borderRadius: '8px', 
            color: colours.primary.grey03, 
            backgroundColor: colours.primary.grey05
        }
    }

    return(
        <div className="ds-card">
            <GridContainer style={{marginTop: 16}}>
                {windowWidth <= 768 ? null : <GridItem xs={1} className="overlay_header_grid_item"></GridItem>}
                <GridItem xs={windowWidth <= 768 ? 12 : 4} className="overlay_header_grid_item">
                    <div style={styles.imageContainer}>
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <div className="overlay_header_image_container" style = {{display: 'flex', height:'auto', borderRadius: 8, overflow: 'hidden'}}>
                                <img className="overlay_header_image" style={{objectFit: 'cover', aspectRatio: '16 / 9'}} src={props.vehicle.photoUrl ? props.vehicle.photoUrl : props.placeholderImage} />
                            </div>
                        </div>
                    </div>
                </GridItem>
                <GridItem xs={windowWidth <= 768 ? 12 : 6} className="overlay_header_grid_item">
                    <div className="overlay_header_bordered">
                        <GridContainer>
                            <GridItem className="overlay_header_grid_item" xs={12}>
                                <div style={{display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row'}}>
                                    <P2Bold style={{color: colours.primary.grey01}}><Trans>Specifications</Trans></P2Bold>
                                    {props.vehicle.specSheetUrl ? (
                                        <Button medium tertiary leading_ic="Specsheet" label="View Spec Sheet" onClick={openSpecSheet}/>
                                    ) : (
                                        <Button medium tertiary label="Add Spec Sheet" onClick={props.editVehicle} leading_ic="AddCircle" style={{padding: 0}}/>
                                    )}
                                </div>
                            </GridItem>
                            <GridItem xs={windowWidth <= 768 ? 12 :6} className="overlay_header_grid_item">
                                <div style={{display: 'flex', flex: 1, justifyContent: 'flex-start', flexDirection: 'column'}}>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="Engine" size={24} style={props.vehicle_oem_details.engine_opt[props.vehicle_details.vehicle.Engine] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.engine.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.engine_opt[props.vehicle_details.vehicle.Engine]}</P3Bold>
                                    </div>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="Transmission" size={24} style={props.vehicle_oem_details.trans_opt[props.vehicle_details.vehicle.Transmission] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.transmission.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.trans_opt[props.vehicle_details.vehicle.Transmission]}</P3Bold>
                                    </div>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="Car" size={24} style={props.vehicle_oem_details.roof_opt[props.vehicle_details.vehicle.Roof] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.roof.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.roof_opt[props.vehicle_details.vehicle.Roof]}</P3Bold>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem xs={windowWidth <= 768 ? 12 :6} className="overlay_header_grid_item">
                                <div style={{display: 'flex', flex: 1, justifyContent: 'flex-start', flexDirection: 'column'}}>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="Tires" size={24} style={props.vehicle_oem_details.tires_opt[props.vehicle_details.vehicle.Tires] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.tires.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.tires_opt[props.vehicle_details.vehicle.Tires]}</P3Bold>
                                    </div>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="Drivetrain" size={24} style={props.vehicle_oem_details.drive_train_opt[props.vehicle_details.vehicle.Drive_Train] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.drive_train.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.drive_train_opt[props.vehicle_details.vehicle.Drive_Train]}</P3Bold>
                                    </div>
                                    <div className="overlay_header_bordered reduced-padding" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <Icon name="BodyType" size={24} style={props.vehicle_oem_details.body_style_opt[props.vehicle_details.vehicle.Body_Style] ? 
                                                styles.activeIconContainerStyle : styles.inactiveIconContainerStyle}/>
                                            <CaptionMedium style={{color: colours.primary.grey02}}>{props.vehicle_options.body_type.name}</CaptionMedium>
                                        </div>
                                        <P3Bold>{props.vehicle_oem_details.body_style_opt[props.vehicle_details.vehicle.Body_Style]}</P3Bold>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </GridItem>
                {windowWidth <= 768 ? null : <GridItem xs={1} className="overlay_header_grid_item"></GridItem>}
            </GridContainer>
            <GridContainer>
                {windowWidth <= 768 ? null : <GridItem xs={1} className="overlay_header_grid_item"></GridItem>}
                <GridItem xs={windowWidth <= 768 ? 12 : 10} className="overlay_header_grid_item">
                    <div>
                        <P3 style={{marginTop: 4, marginBottom: 4}}>
                            <Trans>Accesories & Modifications</Trans>
                        </P3>
                        <div className="overlay_header_bordered">
                        {
                            props.vehicle_details.vehicle.Accessories && props.vehicle_details.vehicle.Accessories !== "" ? 
                                <div className="specs_result">{props.vehicle_details.vehicle.Accessories}</div>
                                : <Button tertiary onClick={props.editVehicle} leading_ic="AddCircle" label={i18n.t('Add Accessories & Modifications')}/>
                        }
                        </div>
                        <P3 style={{marginTop: 16, marginBottom: 4}}>
                            <Trans>Description</Trans>
                        </P3>
                        <div className="overlay_header_bordered">
                        {
                            props.vehicle_details.vehicle.Description && props.vehicle_details.vehicle.Description !== "" ? 
                                <div className="specs_result">{props.vehicle_details.vehicle.Description}</div>
                                : <Button tertiary onClick={props.editVehicle} leading_ic="AddCircle" label={i18n.t('Add Description')}/>
                        }
                        </div>
                    </div>
                </GridItem>
                {windowWidth <= 768 ? null : <GridItem xs={1} className="overlay_header_grid_item"></GridItem>}
            </GridContainer>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings
})

export default connect(mapStateToProps)(VehicleSpecsTab)